"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7629 3H9.2371C4.1941 3 3 4.194 3 9.2371v5.5258C3 19.8059 4.194 21 9.2371 21h5.5258C19.8059 21 21 19.8059 21 14.7629V9.2371C21 4.1941 19.8059 3 14.7629 3zm2.5788 5.7168c.3938 0 .4827.2033.3938.4827-.1388.6405-1.2912 2.3394-1.6481 2.8657-.0678.1-.1069.1576-.1049.1576-.1397.2287-.1905.3303 0 .5843.0689.094.215.2373.3819.4011.1717.1685.3654.3586.52.5389.5589.6352.9908 1.1687 1.1052 1.5371.1016.3684-.0763.5589-.4573.5589h-1.3084c-.3468 0-.5255-.1991-.9064-.6235-.1633-.1819-.3638-.4053-.6307-.6722-.7749-.7494-1.1178-.8511-1.3084-.8511-.2667 0-.343.0636-.343.4446v1.1814c0 .3176-.1016.5081-.94.5081-1.3846 0-2.9216-.8384-4.0014-2.4008-1.626-2.2865-2.0706-4.0141-2.0706-4.3571 0-.1906.0636-.3684.4446-.3684h1.3211c.3303 0 .4573.1397.5844.5081.6478 1.8673 1.7276 3.506 2.1722 3.506.1651 0 .2413-.0762.2413-.4954V10.292c-.0313-.5489-.2224-.788-.3641-.9653-.0878-.11-.1567-.1962-.1567-.3177 0-.1525.127-.3049.3303-.3049h2.0578c.2795 0 .3811.1524.3811.4827v2.6041c0 .2795.1144.3811.2033.3811.1651 0 .3049-.1016.6097-.4065.94-1.0543 1.6133-2.6803 1.6133-2.6803.0889-.1906.2413-.3684.5716-.3684h1.3084z"
  })];
};

exports.default = _default;